import React from 'react';
import { IllustrationProps } from '../../../../../types/Common';
import useToggleIllustrationColors from '../../hooks/useToggleIllustrationColors';

const IllustrationDrones: React.FC<
  React.PropsWithChildren<IllustrationProps>
> = ({ isActive = true, ...otherProps }) => {
  const colors = useToggleIllustrationColors(isActive);
  return (
    <svg
      width={356}
      height={228}
      viewBox="0 0 356 228"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <mask
        id="mask0_3805_10529"
        style={{ maskType: 'alpha' }}
        width="356"
        height="229"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#C0C2C9" d="M0 .998h356v228H0v-228z"></path>
      </mask>
      <g mask="url(#mask0_3805_10529)">
        <path
          fill={colors.primary[50]}
          d="M337 161.998c0 88.366-71.634 160-160 160s-160-71.634-160-160c0-88.365 71.634-160 160-160s160 71.634 160 160z"
        ></path>
        <path
          fill={colors.primary[500]}
          fillRule="evenodd"
          d="M20 226.998a2 2 0 012-2h310a2 2 0 110 4H22a2 2 0 01-2-2z"
          clipRule="evenodd"
        ></path>
        <circle
          cx="90"
          cy="69"
          r="10"
          fill={colors.primary[200]}
          stroke={colors.primary[500]}
          strokeWidth="4"
        ></circle>
        <path
          stroke={colors.primary[500]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M90 58.5v-18"
        ></path>
        <path
          fill="#fff"
          stroke={colors.primary[500]}
          strokeWidth="4"
          d="M89 41c0 .435-.195 1.012-.884 1.715-.697.713-1.804 1.447-3.328 2.106C81.745 46.137 77.402 47 72.5 47s-9.245-.863-12.288-2.179c-1.524-.66-2.631-1.393-3.328-2.105C56.195 42.011 56 41.434 56 41c0-.435.195-1.012.884-1.715.697-.713 1.804-1.447 3.328-2.106C63.255 35.863 67.598 35 72.5 35s9.245.863 12.288 2.179c1.524.66 2.631 1.393 3.328 2.105.689.704.884 1.281.884 1.716zM125 41c0 .435-.195 1.012-.884 1.715-.697.713-1.804 1.447-3.328 2.106C117.745 46.137 113.402 47 108.5 47s-9.245-.863-12.288-2.179c-1.524-.66-2.631-1.393-3.328-2.105C92.195 42.011 92 41.434 92 41c0-.435.195-1.012.884-1.715.697-.713 1.804-1.447 3.328-2.106C99.255 35.863 103.598 35 108.5 35s9.245.863 12.288 2.179c1.524.66 2.631 1.393 3.328 2.105.689.704.884 1.281.884 1.716z"
        ></path>
        <circle
          cx="266"
          cy="69"
          r="10"
          fill={colors.primary[200]}
          stroke={colors.primary[500]}
          strokeWidth="4"
        ></circle>
        <path
          stroke={colors.primary[500]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M266 58.5v-18"
        ></path>
        <path
          fill="#fff"
          stroke={colors.primary[500]}
          strokeWidth="4"
          d="M265 41c0 .435-.195 1.012-.884 1.715-.697.713-1.804 1.447-3.328 2.106C257.745 46.137 253.402 47 248.5 47s-9.245-.863-12.288-2.179c-1.524-.66-2.631-1.393-3.328-2.105-.689-.704-.884-1.281-.884-1.716 0-.435.195-1.012.884-1.715.697-.713 1.804-1.447 3.328-2.106C239.255 35.863 243.598 35 248.5 35s9.245.863 12.288 2.179c1.524.66 2.631 1.393 3.328 2.105.689.704.884 1.281.884 1.716zM301 41c0 .435-.195 1.012-.884 1.715-.697.713-1.804 1.447-3.328 2.106C293.745 46.137 289.402 47 284.5 47s-9.245-.863-12.288-2.179c-1.524-.66-2.631-1.393-3.328-2.105-.689-.704-.884-1.281-.884-1.716 0-.435.195-1.012.884-1.715.697-.713 1.804-1.447 3.328-2.106C275.255 35.863 279.598 35 284.5 35s9.245.863 12.288 2.179c1.524.66 2.631 1.393 3.328 2.105.689.704.884 1.281.884 1.716z"
        ></path>
        <path
          fill="#fff"
          stroke={colors.primary[500]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M144.243 105.458a8 8 0 01.8 11.285l-23.628 27.232a16 16 0 00-3.915 10.486V193a8 8 0 01-16 0v-38.539a32 32 0 017.83-20.972l23.627-27.232a8 8 0 0111.286-.799zM211.257 105.458a8 8 0 00-.8 11.285l23.628 27.232A16 16 0 01238 154.461V193a8 8 0 0016 0v-38.539a32 32 0 00-7.83-20.972l-23.627-27.232a8 8 0 00-11.286-.799z"
        ></path>
        <rect
          width="80"
          height="54"
          x="139"
          y="94"
          fill={colors.primary[200]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          rx="16"
        ></rect>
        <circle
          cx="179"
          cy="178"
          r="30"
          fill="#fff"
          stroke={colors.primary[500]}
          strokeWidth="4"
        ></circle>
        <circle
          cx="179"
          cy="178"
          r="14"
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
        ></circle>
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M102.5 71c34.214 0 43.464-6.613 51.325-12.234C159.636 54.612 164.688 51 178.5 51c13.812 0 18.864 3.612 24.675 7.766C211.036 64.387 220.286 71 254.5 71H276c11 0 21 12.5 21 23s-10 23-21 23h-21.5c-34.214 0-43.464 6.613-51.325 12.234-5.811 4.154-10.863 7.766-24.675 7.766-13.812 0-18.864-3.612-24.675-7.766C145.964 123.613 136.714 117 102.5 117H81c-11 0-21-12.5-21-23s10-23 21-23h21.5z"
          clipRule="evenodd"
        ></path>
        <path
          fill={colors.primary[500]}
          d="M153.825 58.766l1.164 1.627-1.164-1.627zm49.35 0l1.163-1.627-1.163 1.627zm0 70.468l1.163 1.627-1.163-1.627zm-49.35 0l1.164-1.627-1.164 1.627zm-1.163-72.095c-3.888 2.78-7.954 5.684-15.212 7.942C130.139 67.356 119.492 69 102.5 69v4c17.221 0 28.306-1.662 36.139-4.1 7.886-2.453 12.376-5.666 16.35-8.507l-2.327-3.254zM178.5 49c-7.084 0-12.054.927-16.053 2.458-3.985 1.525-6.892 3.613-9.785 5.681l2.327 3.254c2.917-2.085 5.442-3.88 8.888-5.2C167.31 53.88 171.772 53 178.5 53v-4zm0 4c6.728 0 11.19.88 14.623 2.193 3.446 1.32 5.971 3.115 8.888 5.2l2.327-3.254c-2.893-2.068-5.8-4.156-9.785-5.681C190.554 49.927 185.584 49 178.5 49v4zm23.511 7.393c3.974 2.841 8.464 6.054 16.35 8.508C226.194 71.338 237.279 73 254.5 73v-4c-16.992 0-27.639-1.644-34.95-3.919-7.258-2.258-11.324-5.162-15.212-7.942l-2.327 3.254zM254.5 73H276v-4h-21.5v4zm21.5 0c4.741 0 9.485 2.717 13.119 6.878C292.75 84.036 295 89.336 295 94h4c0-5.836-2.75-12.036-6.869-16.753C288.015 72.533 282.259 69 276 69v4zm19 21c0 4.664-2.25 9.964-5.881 14.122C285.485 112.283 280.741 115 276 115v4c6.259 0 12.015-3.533 16.131-8.247C296.25 106.036 299 99.836 299 94h-4zm-19 21h-21.5v4H276v-4zm-21.5 0c-17.221 0-28.306 1.662-36.139 4.099-7.886 2.454-12.376 5.667-16.35 8.508l2.327 3.254c3.888-2.78 7.954-5.684 15.212-7.942 7.311-2.275 17.958-3.919 34.95-3.919v-4zm-52.489 12.607c-2.917 2.085-5.442 3.881-8.888 5.2-3.433 1.314-7.895 2.193-14.623 2.193v4c7.084 0 12.054-.927 16.053-2.457 3.985-1.526 6.892-3.614 9.785-5.682l-2.327-3.254zm-49.349 3.254c2.893 2.068 5.8 4.156 9.785 5.682 3.999 1.53 8.969 2.457 16.053 2.457v-4c-6.728 0-11.19-.879-14.623-2.193-3.446-1.319-5.971-3.115-8.888-5.2l-2.327 3.254zM102.5 119c16.992 0 27.639 1.644 34.95 3.919 7.258 2.258 11.324 5.162 15.212 7.942l2.327-3.254c-3.974-2.841-8.464-6.054-16.35-8.508-7.833-2.437-18.918-4.099-36.139-4.099v4zM81 119h21.5v-4H81v4zM58 94c0 5.836 2.75 12.036 6.868 16.753C68.986 115.467 74.742 119 81 119v-4c-4.741 0-9.485-2.717-13.118-6.878C64.25 103.964 62 98.664 62 94h-4zm23-25c-6.259 0-12.015 3.533-16.132 8.247C60.75 81.964 58 88.164 58 94h4c0-4.664 2.25-9.964 5.882-14.122C71.514 75.718 76.258 73 81 73v-4zm21.5 0H81v4h21.5v-4z"
        ></path>
        <mask
          id="mask1_3805_10529"
          style={{ maskType: 'alpha' }}
          width="241"
          height="90"
          x="58"
          y="49"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill="#fff"
            fillRule="evenodd"
            d="M102.5 71c34.214 0 43.464-6.613 51.325-12.234C159.636 54.612 164.688 51 178.5 51c13.812 0 18.864 3.612 24.675 7.766C211.036 64.387 220.286 71 254.5 71H276c11 0 21 12.5 21 23s-10 23-21 23h-21.5c-34.214 0-43.464 6.613-51.325 12.234-5.811 4.154-10.863 7.766-24.675 7.766-13.812 0-18.864-3.612-24.675-7.766C145.964 123.613 136.714 117 102.5 117H81c-11 0-21-12.5-21-23s10-23 21-23h21.5z"
            clipRule="evenodd"
          ></path>
          <path
            fill={colors.primary[500]}
            d="M153.825 58.766l1.164 1.627-1.164-1.627zm49.35 0l1.163-1.627-1.163 1.627zm0 70.468l1.163 1.627-1.163-1.627zm-49.35 0l1.164-1.627-1.164 1.627zm-1.163-72.095c-3.888 2.78-7.954 5.684-15.212 7.942C130.139 67.356 119.492 69 102.5 69v4c17.221 0 28.306-1.662 36.139-4.1 7.886-2.453 12.376-5.666 16.35-8.507l-2.327-3.254zM178.5 49c-7.084 0-12.054.927-16.053 2.458-3.985 1.525-6.892 3.613-9.785 5.681l2.327 3.254c2.917-2.085 5.442-3.88 8.888-5.2C167.31 53.88 171.772 53 178.5 53v-4zm0 4c6.728 0 11.19.88 14.623 2.193 3.446 1.32 5.971 3.115 8.888 5.2l2.327-3.254c-2.893-2.068-5.8-4.156-9.785-5.681C190.554 49.927 185.584 49 178.5 49v4zm23.511 7.393c3.974 2.841 8.464 6.054 16.35 8.508C226.194 71.338 237.279 73 254.5 73v-4c-16.992 0-27.639-1.644-34.95-3.919-7.258-2.258-11.324-5.162-15.212-7.942l-2.327 3.254zM254.5 73H276v-4h-21.5v4zm21.5 0c4.741 0 9.485 2.717 13.119 6.878C292.75 84.036 295 89.336 295 94h4c0-5.836-2.75-12.036-6.869-16.753C288.015 72.533 282.259 69 276 69v4zm19 21c0 4.664-2.25 9.964-5.881 14.122C285.485 112.283 280.741 115 276 115v4c6.259 0 12.015-3.533 16.131-8.247C296.25 106.036 299 99.836 299 94h-4zm-19 21h-21.5v4H276v-4zm-21.5 0c-17.221 0-28.306 1.662-36.139 4.099-7.886 2.454-12.376 5.667-16.35 8.508l2.327 3.254c3.888-2.78 7.954-5.684 15.212-7.942 7.311-2.275 17.958-3.919 34.95-3.919v-4zm-52.489 12.607c-2.917 2.085-5.442 3.881-8.888 5.2-3.433 1.314-7.895 2.193-14.623 2.193v4c7.084 0 12.054-.927 16.053-2.457 3.985-1.526 6.892-3.614 9.785-5.682l-2.327-3.254zm-49.349 3.254c2.893 2.068 5.8 4.156 9.785 5.682 3.999 1.53 8.969 2.457 16.053 2.457v-4c-6.728 0-11.19-.879-14.623-2.193-3.446-1.319-5.971-3.115-8.888-5.2l-2.327 3.254zM102.5 119c16.992 0 27.639 1.644 34.95 3.919 7.258 2.258 11.324 5.162 15.212 7.942l2.327-3.254c-3.974-2.841-8.464-6.054-16.35-8.508-7.833-2.437-18.918-4.099-36.139-4.099v4zM81 119h21.5v-4H81v4zM58 94c0 5.836 2.75 12.036 6.868 16.753C68.986 115.467 74.742 119 81 119v-4c-4.741 0-9.485-2.717-13.118-6.878C64.25 103.964 62 98.664 62 94h-4zm23-25c-6.259 0-12.015 3.533-16.132 8.247C60.75 81.964 58 88.164 58 94h4c0-4.664 2.25-9.964 5.882-14.122C71.514 75.718 76.258 73 81 73v-4zm21.5 0H81v4h21.5v-4z"
          ></path>
        </mask>
        <g mask="url(#mask1_3805_10529)">
          <path
            fill={colors.primary[100]}
            stroke={colors.primary[500]}
            strokeWidth="4"
            d="M97 62h11v29.5a5.5 5.5 0 11-11 0V62zM247 62h11v29.5a5.5 5.5 0 11-11 0V62zM122 61h11v30.5a5.5 5.5 0 11-11 0V61zM222 61h11v30.5a5.5 5.5 0 11-11 0V61z"
          ></path>
          <path
            stroke={colors.primary[500]}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="4"
            d="M145 80.5v12M155 80.5v12M200 80.5v12M210 80.5v12"
          ></path>
          <path
            fill={colors.primary[500]}
            d="M153.825 58.766l1.164 1.627-1.164-1.627zm49.35 0l1.163-1.627-1.163 1.627zm0 70.468l1.163 1.627-1.163-1.627zm-49.35 0l1.164-1.627-1.164 1.627zm-1.163-72.095c-3.888 2.78-7.954 5.684-15.212 7.942C130.139 67.356 119.492 69 102.5 69v4c17.221 0 28.306-1.662 36.139-4.1 7.886-2.453 12.376-5.666 16.35-8.507l-2.327-3.254zM178.5 49c-7.084 0-12.054.927-16.053 2.458-3.985 1.525-6.892 3.613-9.785 5.681l2.327 3.254c2.917-2.085 5.442-3.88 8.888-5.2C167.31 53.88 171.772 53 178.5 53v-4zm0 4c6.728 0 11.19.88 14.623 2.193 3.446 1.32 5.971 3.115 8.888 5.2l2.327-3.254c-2.893-2.068-5.8-4.156-9.785-5.681C190.554 49.927 185.584 49 178.5 49v4zm23.511 7.393c3.974 2.841 8.464 6.054 16.35 8.508C226.194 71.338 237.279 73 254.5 73v-4c-16.992 0-27.639-1.644-34.95-3.919-7.258-2.258-11.324-5.162-15.212-7.942l-2.327 3.254zM254.5 73H276v-4h-21.5v4zm21.5 0c4.741 0 9.485 2.717 13.119 6.878C292.75 84.036 295 89.336 295 94h4c0-5.836-2.75-12.036-6.869-16.753C288.015 72.533 282.259 69 276 69v4zm19 21c0 4.664-2.25 9.964-5.881 14.122C285.485 112.283 280.741 115 276 115v4c6.259 0 12.015-3.533 16.131-8.247C296.25 106.036 299 99.836 299 94h-4zm-19 21h-21.5v4H276v-4zm-21.5 0c-17.221 0-28.306 1.662-36.139 4.099-7.886 2.454-12.376 5.667-16.35 8.508l2.327 3.254c3.888-2.78 7.954-5.684 15.212-7.942 7.311-2.275 17.958-3.919 34.95-3.919v-4zm-52.489 12.607c-2.917 2.085-5.442 3.881-8.888 5.2-3.433 1.314-7.895 2.193-14.623 2.193v4c7.084 0 12.054-.927 16.053-2.457 3.985-1.526 6.892-3.614 9.785-5.682l-2.327-3.254zm-49.349 3.254c2.893 2.068 5.8 4.156 9.785 5.682 3.999 1.53 8.969 2.457 16.053 2.457v-4c-6.728 0-11.19-.879-14.623-2.193-3.446-1.319-5.971-3.115-8.888-5.2l-2.327 3.254zM102.5 119c16.992 0 27.639 1.644 34.95 3.919 7.258 2.258 11.324 5.162 15.212 7.942l2.327-3.254c-3.974-2.841-8.464-6.054-16.35-8.508-7.833-2.437-18.918-4.099-36.139-4.099v4zM81 119h21.5v-4H81v4zM58 94c0 5.836 2.75 12.036 6.868 16.753C68.986 115.467 74.742 119 81 119v-4c-4.741 0-9.485-2.717-13.118-6.878C64.25 103.964 62 98.664 62 94h-4zm23-25c-6.259 0-12.015 3.533-16.132 8.247C60.75 81.964 58 88.164 58 94h4c0-4.664 2.25-9.964 5.882-14.122C71.514 75.718 76.258 73 81 73v-4zm21.5 0H81v4h21.5v-4z"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export default IllustrationDrones;
